<template>
  <div v-if="!isEmpty" class="question-setting">
    <el-tabs type="card" v-model="activeTab" class="flex-tabs">
      <el-tab-pane label="问题设置" name="0"> </el-tab-pane>
    </el-tabs>
    <div class="mt-5 text-large text-theme-black-850 font-medium leading-22 font-MEDIUM">
      <span>Q{{ question.num }}.</span>
      <span>题目设置</span>
    </div>
    <div class="text-theme-black-850 question-setting-item font-MEDIUM">
      <div class="leading-22 mb-3 font-bold text-medium">
        <span>整体设置</span>
      </div>
      <ul :key="question.q_id">
        <li>
          <div class="w-full">
            <div class="flex-between">
              <span>此题必答</span>
              <el-switch
                :disabled="question.num < 3"
                v-model="question.is_required"
                @change="onUpdate"
              ></el-switch>
            </div>
          </div>
        </li>
        <li v-if="question.num > 2">
          <span
            >题目隐藏
            <el-tooltip
              effect="light"
              :content="`开启后，该字段只有企业内部人员可见，${
                isCustomer ? '客户': isInvestigator ? '调查员' : '代理商'
              }申请填报将看不到此字段；通常适用于你想为已提交数据设置一些特殊属性，如状态（处理/未处理）或优先级（重要/一般）。`"
            >
              <span>
                <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
              </span>
            </el-tooltip>
          </span>
          <el-switch v-model="question.setting.hidden" @input="onChangeHidden" />
        </li>
      </ul>
    </div>
  </div>
  <div v-else>
    <div class="text-center text-theme-black-450" style="padding-top: 200px">
      <span style="font-size: 40px">
        <i class="icon-bianji1"></i>
      </span>
      <div class="leading-22 mt-4 text-medium">
        <span>没有选定的题目</span>
        <br />
        <span>请添加或者选择一个题目</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    surveyId: {
      type: String,
      default: ''
    },
    isInvestigator: {
      type: Boolean,
      default: false
    },
    isCustomer:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: '0'
    }
  },
  computed: {
    isEmpty() {
      return !this.question
    },
    question() {
      return this.selectQuestion
    },
    ...mapGetters(['selectQuestion', 'selectIssueItem'])
  },
  methods: {
    onUpdate() {
      this.$emit('on-update', this.question)
    },
    onChangeHidden() {
      this.onUpdate()
    }
  }
}
</script>

<style></style>
